import React from 'react';
import { FadeIn } from './FadeIn';
import { Trophy, Rocket, Clock, TrendingUp, GraduationCap } from 'lucide-react';
export function SolutionOverview() {
  const benefits = [{
    icon: <Rocket size={22} data-id="element-222" />,
    title: 'Intervenciones más claras',
    desc: 'Actividades, secuencias y recursos listos para conciencia fonológica, letras, escritura, lectura, comprensión y producción escrita.'
  }, {
    icon: <Clock size={22} data-id="element-223" />,
    title: 'Más tiempo para vos',
    desc: 'Dejás de armar todo desde cero y trabajás con una estructura práctica y ordenada.'
  }, {
    icon: <TrendingUp size={22} data-id="element-224" />,
    title: 'Más organización profesional',
    desc: 'Materiales para intervenir, registrar, seguir avances y comunicar mejor tu trabajo.'
  }, {
    icon: <GraduationCap size={22} data-id="element-225" />,
    title: 'Más seguridad en tu práctica',
    desc: 'Te sentís más preparada para elegir recursos, sostener procesos y acompañar a cada niño con claridad.'
  }];
  return <section className="pt-8 pb-6 px-4 max-w-4xl mx-auto" data-id="element-226">
      <FadeIn className="text-center mb-8" data-id="element-227">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-mint/20 text-mint mb-4" data-id="element-228">
          <Trophy size={32} data-id="element-229" />
        </div>
        <h2 className="font-display text-3xl md:text-4xl font-bold text-mint mb-3" data-id="element-230">
          Lo que vas a lograr con este sistema
        </h2>
        <p className="text-xl text-mint/70 font-medium mb-5" data-id="element-231">
          (consultorio, gabinete y apoyo escolar — sin vueltas)
        </p>

        <div className="bg-surface p-8 rounded-2xl shadow-md border border-mint/10 mb-6" data-id="element-232">
          <h3 className="font-bold text-2xl text-mint mb-2" data-id="element-233">
            ✏️ MEGAPACK PRO - PLANIFICACIONES ÉLITE
          </h3>
          <p className="font-medium text-mint bg-mint/10 inline-block px-4 py-2 rounded-lg" data-id="element-234">
            +360 páginas · 6 Tomos · 6 Bonos · 5 Recursos PRO. Listo para
            imprimir y usar.
          </p>
        </div>
      </FadeIn>

      <div className="grid md:grid-cols-2 gap-4 mb-8" data-id="element-235">
        {benefits.map((b, idx) => <FadeIn key={idx} delay={idx * 0.08} className="flex items-start gap-3 bg-surface p-5 rounded-xl border border-mint/10" data-id="element-236">
            <div className="shrink-0 w-10 h-10 rounded-lg bg-mint/15 text-mint flex items-center justify-center" data-id="element-237">
              {b.icon}
            </div>
            <div data-id="element-238">
              <h4 className="font-bold text-white mb-1" data-id="element-239">{b.title}</h4>
              <p className="text-sm text-white/60 leading-snug" data-id="element-240">{b.desc}</p>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}